import React from 'react';
import styled from 'styled-components';
import Humanize from 'humanize-plus';
import { font, ChartCell, ChartCellWrapper } from './sharedStyles';
import { getColumnBorderFlags } from './columnBorderFlags';

const PosNegText = styled('div')<{ color: string }>`
  color: ${({ color }) => color};
  position: absolute;
  z-index: 2;
  top: 5px;
  left: 0px;
  text-align: center;
  letter-spacing: -0.3px;
  font-size: 13px;
  width: 100%;
  height: 100%;
  ${font}
`;

export const PosNegPercentRenderer =
  (
    dataColors: any,
    firstColumnIds: Set<string>,
    lastColumnIds: Set<string>,
    columnIds: string[],
    hasScroll: boolean | undefined,
    dataMidPoints: number[] | undefined,
  ) =>
  // eslint-disable-next-line react/display-name
  ({ dataKey, rowData, cellData, columnIndex }: any) => {
    const columnIdx = typeof columnIndex === 'number' ? columnIndex : 0;
    const midPoint = dataMidPoints?.[columnIdx] || 0;
    const colors = rowData[`${dataKey}Color`] || dataColors;
    const { isFirst, isLast } = getColumnBorderFlags(columnIds, columnIndex, firstColumnIds, lastColumnIds, hasScroll);

    return (
      <ChartCell $isfirst={isFirst ? 1 : 0} $islast={isLast ? 1 : 0}>
        <ChartCellWrapper>
          <PosNegText
            color={Number(cellData) < midPoint ? colors[0] : Number(cellData) > midPoint ? colors[1] : '#000'}
          >
            {Number(isNaN(cellData)) ? '-' : `${Humanize.toFixed(cellData, 2).replace('.00', '')}%`}
          </PosNegText>
        </ChartCellWrapper>
      </ChartCell>
    );
  };
